import React from "react";
import { createRoot } from "react-dom/client";
import { WelcomeBanner } from "./components/banner/WelcomeBanner";
import { storageFactory } from "./utils/storageFactory";
import { ApolloProvider } from "@apollo/client";
import { apolloClient } from "./utils/apollo";
import { GuestGoPaperlessModal } from "./components/go_paperless/GuestGoPaperlessModal";
import { TranslationSupportCallout } from "./components/translation_support_callout/TranslationSupportCallout";
import { cloneHeaderToInvisibleNavbar } from "./utils/mainPaddingTop";
import { RealTimeBalanceStatusPoller } from "./components/real_time_balance_status_poller/RealTimeBalanceStatusPoller";
import { renderKoraChat, isKoraChatEnabled } from "./next_js/common/kora-chat/utils";

(async () => {
    const response: any = await fetch("/api/patient/configuration-editor/");
    if (response.ok) {
        const data: any = await response.json();
        const welcomeBanner = data?.welcomeBanner;
        const WELCOME_BANNER_KEY = `welcome banner key: ${data?.provider} : ${data?.pbu}`;
        const sessionStore = storageFactory(() => sessionStorage);
        const showBanner = sessionStore.getItem(WELCOME_BANNER_KEY) !== "true";
        const otherBannerIsDisplayed = $("._banner_above_nav:visible").length > 0;

        if (welcomeBanner?.body && showBanner && !otherBannerIsDisplayed) {
            if ($(".welcome-banner").length === 0) {
                $('<div class="welcome-banner relative z-10" />').prependTo($("header.fixed"));
            }
            const container = $("header.fixed > .welcome-banner").get(0) as HTMLElement;
            const {
                takeAction,
                title,
                body,
                style,
                showIcon,
                iconName,
                linkInternal,
                urlParam,
                isSearchParam,
                searchParamValue,
            } = welcomeBanner;
            const root = createRoot(container);
            root.render(
                <ApolloProvider client={apolloClient}>
                    <WelcomeBanner
                        takeAction={takeAction}
                        title={title}
                        content={body}
                        bannerStyle={style}
                        showIcon={showIcon}
                        iconName={iconName}
                        linkInternal={linkInternal}
                        urlParam={urlParam}
                        isSearchParam={isSearchParam}
                        searchParamValue={searchParamValue}
                        userPublicId={cedar.serverDataGlobal.user_public_id}
                        onClose={() => {
                            sessionStore.setItem(WELCOME_BANNER_KEY, "true");
                            $(".invisible .welcome-banner").remove();
                        }}
                    />
                </ApolloProvider>,
            );

            cloneHeaderToInvisibleNavbar();
        }
    }

    if ($("#guest-go-paperless-modal").length === 0) {
        $('<div id="guest-go-paperless-modal"/>').prependTo($("main"));
    }
    const container = $("main #guest-go-paperless-modal").get(0) as HTMLElement;
    const guestRoot = createRoot(container);
    guestRoot.render(
        <ApolloProvider client={apolloClient}>
            <GuestGoPaperlessModal />
        </ApolloProvider>,
    );

    if ($("#translation_support_cta").length !== 0) {
        const container = $("#translation_support_cta").get(0) as HTMLElement;
        const translationRoot = createRoot(container);
        translationRoot.render(
            <ApolloProvider client={apolloClient}>
                <TranslationSupportCallout />
            </ApolloProvider>,
        );
    }

    if ($("#real_time_balance_status_poller").length !== 0) {
        const container = $("#real_time_balance_status_poller").get(0) as HTMLElement;
        const pollerRoot = createRoot(container);
        pollerRoot.render(
            <ApolloProvider client={apolloClient}>
                <RealTimeBalanceStatusPoller />
            </ApolloProvider>,
        );
    }

    if (isKoraChatEnabled()) {
        renderKoraChat();
    }
})();
